<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Which item did you have a question about?</h1>
			<div v-if="!loading">
				<div v-if="orders.length" class="h-orders-list">
					<v-expansion-panel flat="is_mobile" expand v-model="orders_panel">
						<v-expansion-panel-content
								v-for="(order, i) in orders"
								:key="i"
								class="v-orders-panel"
						>
							<div slot="header" class="h-orders-list-header">
								<div v-if="!is_mobile">Order: </div>
								<div class="order_id">
									<span v-if="is_mobile">» </span>
									<span>{{ order['id'] }}</span>
								</div>
								<span class="order_date">
									<strong v-if="is_mobile">Ordered on </strong>{{ format(order['order_date']) }}
								</span>
							</div>

							<v-card v-for="book in order['books']" :key="book['id']" class="h-orders-list-card">
								<v-card-text>

									<v-layout>
										<v-flex xs2 v-if="!is_mobile">
											<v-img
													:src="book['cover']"
													height="125px"
													max-width="80%"
											></v-img>
										</v-flex>
										<v-flex xs10>
											<div>
												<strong>{{ book['book_title'] }}</strong><span
													v-if="book['book_author']">{{ `, ${book['book_author']}` }}</span>
											</div>
											<div>
												<strong>ISBN:</strong>
												<span>{{ book['book_isbn'] }}</span>
											</div>
											<div>
												<strong>Condition:</strong>
												<span>{{ book['condition_print'] }}</span>
											</div>
											<div v-if="book['backorder'] && !book['shipped']" class="body-1 font-italic">
												*Note: In stock soon! Ships when available.
											</div>
											<div class="h-order-line-controls">
												<v-btn color="#7DADED" large round dark :to="`/help_with_my_order_item/${book['condition']}/${book['id']}`">Pick
												</v-btn>
											</div>
										</v-flex>
									</v-layout>
								</v-card-text>
							</v-card>
						</v-expansion-panel-content>
					</v-expansion-panel>

					<div class="text-xs-center mt-4" v-if="show_more_button">
						<v-btn
								:flat="is_mobile"
								:round="is_mobile"
								@click="showMoreOrders"
								:disabled="loading_show_more"
								:loading="loading_show_more"
								class="h-order-show-more-btn"
						>
							Show more
						</v-btn>
					</div>
				</div>

				<div v-else-if="!isNoAccountCustomer()">
					<p role="alert" aria-live="assertive" tabindex="0" class="ada-focus">
						We see you don't have any order attached to this account, please contact customer
						service if you are having trouble finding your account.
					</p>

					<email-form
							caption="Contact Us"
							subject="Having trouble finding my account"
							:body="email_body"
							on-success-url="/help?#/submitted"
							edit-body
							edit-subject
							must-edit
							destination-key="cs"
					></email-form>
				</div>

			</div>
			<div v-if="!loading && isNoAccountCustomer()" class="mt-5">
				<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Want to log in or see another order?</h1>
				<login-form :return-url="`/help#${$route.path}`" by-order></login-form>
			</div>
		</div>

		<base-nav-links home no-back></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import Axios from 'axios';
	import BaseNavLinks from './../components/BaseNavLinks';
	import LoginForm from './../components/LoginForm';
	import EmailForm from "./../components/EmailForm";
	import {formatDate} from './../../helpers';

	export default {
		name: "HelpWithMyOrder",

		components: {
			EmailForm,
			BaseNavLinks,
			LoginForm,
		},

		data() {
			return {
				loading: false,
				loading_show_more: false,
				orders: [],
				orders_count: 0,
				last_order_id: 0,
				orders_panel: [],
				email_body: "I can't figure out which account I used to place my order, can you help?"
			}
		},

		mounted() {
			this.loading = true;
			this.getOrders(0);
		},

		computed: {
			show_more_button() {
				return this.orders_count > this.orders.length;
			}
		},

		methods: {
			getOrders(last_order_id) {
				if (_.isUndefined(last_order_id)) last_order_id = 0;

				const self = this;

				Axios.get('/service/customer_help/rest/index.php/customer_help/get_orders/' + last_order_id)
					.then(function (response) {
						if (response.status === 200 && response.data && response.data['status'] === 'success') {
							if (!_.isUndefined(response.data['data']['orders'])) {
								let new_orders = response.data['data']['orders'];
								self.orders_count = response.data['data']['orders_count'];
								self.last_order_id = response.data['data']['last_order_id'];
								self.orders = [...self.orders, ...new_orders];
								self.orders_panel = [...self.orders_panel, ...new_orders];
							}
						}
					})
					.finally(function () {
						self.loading = false;
						self.loading_show_more = false;
					});
			},

			showMoreOrders() {
				this.loading_show_more = true;
				this.getOrders(this.last_order_id);
			},

			isNoAccountCustomer() {
				return this.$globs['customer_info'] && (this.$globs['customer_info']['reg_order'] === '1');
			},

			format(x) {
				return formatDate(x);
			},
		}
	}
</script>

<style scoped lang="less">
	.h-orders-list {
		margin-bottom: 70px;
	}

	.h-orders-list-header {
		font-style: normal;

		> div {
			float: left;
			margin-right: 20px;
		}

		> span {
			display: block;
			float: right;
			margin-right: 30px;
		}
	}

	.h-order-line-controls {
		margin-top: 10px;
	}

	.v-orders-panel {
		background-color: #f7f8fa !important;
	}

	.h-orders-list-card {
		border-top: 1px solid #E7E8EC;
	}

	@media screen and (min-width : 320px) and (max-width : 480px) {
		.h-orders-list {
			div {
				margin: 0 auto;
			}
		}
	}
</style>